// DynamicLandingPage.js
import React from "react";
import Layout from "../components/Layout/HomeLayout";
import Form from "../components/Contact/Form";
import "./nyetrips.css";
import banner1 from "../images/bannernew.jpeg";
import banner2 from "../images/bannerimage.jpg";
import banner3 from "../images/bannnerimages.jpeg";
import banner4 from "../images/Domesticbanner.png";
import banner5 from "../images/Internationalbanner.png"
const pageData = {
 "domestic-trips": {
    title: "Best Domestic Trips",
    subTitle: "Explore amazing destinations across India",
    videoUrl:
      // "https://www.youtube.com/embed/8UWS99hw_mo?autoplay=1&mute=1&loop=1&playlist=8UWS99hw_mo&rel=0",
    "https://player.vimeo.com/video/1133483233?autoplay=1&muted=1&loop=1&background=1",
    bannerImage: banner4,
  },
  "international-trips": {
  title: "Top International Trips",
  subTitle: "Travel to breathtaking international destinations",
  videoUrl:
    "https://www.youtube.com/embed/IO4F3zZ0OPQ?autoplay=1&mute=1&loop=1&playlist=IO4F3zZ0OPQ&rel=0",
  bannerImage: banner5,
},

  "nye-trips": {
  title: "New Year Eve Trips",
  subTitle: "Celebrate NYE at exotic locations",
  videoUrl:
    "https://www.youtube.com/embed/PxHBC0MgNds?autoplay=1&mute=1&loop=1&playlist=PxHBC0MgNds&rel=0",
  bannerImage: banner5,
},

 "nye-domestic-trips": {
    title: "NYE Domestic Trips",
    subTitle: "Celebrate New Year in India's most exciting locations",
    videoUrl:
      "https://www.youtube.com/embed/IStb-57fXwo?autoplay=1&mute=1&loop=1&playlist=IStb-57fXwo",
    bannerImage: banner4,

  },
   "all-trips": {
    title: "All Trips",
    subTitle: "Explore all travel packages in one place",
    videoUrl:
      "https://www.youtube.com/embed/oGqS9VIgMwo?autoplay=1&mute=1&loop=1&playlist=oGqS9VIgMwo&rel=0",
    bannerImage: banner4,
  },
  "nye-international-trips": {
  title: "NYE International Trips",
  subTitle: "Ring in the New Year overseas in style",
  videoUrl:
    "https://www.youtube.com/embed/3zcRi0F8v3Y?autoplay=1&mute=1&loop=1&playlist=3zcRi0F8v3Y&rel=0",
  bannerImage: banner5,
},

   "ladakh-winter-trip": {
  title: "Ladakh Winter Trip",
  subTitle: "Celebrate New Year in India's most exciting locations",
  videoUrl: "https://www.youtube.com/embed/QY3541e2naY?autoplay=1&mute=1&loop=1&playlist=QY3541e2naY&rel=0",
  bannerImage: banner5,
},

   "summer-bike-trips": {
    title: "Summer Bike Adventures",
    subTitle: "Thrilling road trips for bike lovers",
    videoUrl: "https://www.youtube.com/embed/QY3541e2naY?autoplay=1&mute=1&loop=1&playlist=QY3541e2naY&rel=0",
    bannerImage: banner5,
  },
  "ladakh-summer-trip-2026": {
    title: "Ladakh Summer Trip 2026",
    subTitle: "Thrilling road trips for bike lovers",
videoUrl:
  "https://www.youtube.com/embed/8UWS99hw_mo?autoplay=1&mute=1&loop=1&playlist=8UWS99hw_mo&rel=0&modestbranding=1&controls=0&showinfo=0&iv_load_policy=3&fs=0",
    bannerImage: banner4,
    formWidth: "600px"   // 🔥 Custom width for desktop
  },
   "kashmir-winter-trip": {
    title: "Kashmir Winter Trip",
    subTitle: "Celebrate New Year in India's most exciting locations",
    videoUrl: "https://www.youtube.com/embed/8UWS99hw_mo?autoplay=1&mute=1&loop=1&playlist=8UWS99hw_mo&rel=0",

    bannerImage: banner4,
  },
};

const DynamicLandingPage = ({ pageSlug }) => {
  const config = pageData[pageSlug];
const pagesWithCenterForm = [
  "nye-international-trips",
  "nye-trips",
  "nye-domestic-trips",
  "all-trips",
  "domestic-trips",
   "international-trips",
   "ladakh-winter-trip",
   "summer-bike-trips",
   "ladakh-summer-trip-2026",
    "kashmir-winter-trip"
];

const isCenterFormPage = pagesWithCenterForm.includes(pageSlug);

  if (!config) return <h2>Page Not Found</h2>;

  return (
    <Layout title={config.title} subTitle={config.subTitle}>
    {config.videoUrl && (
  <div className={`ads-video-banner ${pageSlug}`}>
    <iframe
      className="ads-video"
      src={config.videoUrl}
      allow="autoplay"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  </div>
)}


    <div
  className={`dynamic-landing-page ${
    ["ladakh-summer-trip-2026", "nye-domestic-trips", "domestic-trips","summer-bike-trips","international-trips",
   "ladakh-winter-trip", "nye-international-trips",
  "nye-trips",  "all-trips",
   
    "kashmir-winter-trip"].includes(pageSlug)
      ? "custom-form-page"
      : ""
  }`}
>
  <div className="ads-banner-section">
    <div
      className={`ads-banner ${isCenterFormPage ? "banner-opacity" : ""}`}
      style={{ backgroundImage: `url(${config.bannerImage})` }}
    ></div>

    <div className={`ads-form-overlay ${isCenterFormPage ? "center-form-desktop" : ""}`}>
      <Form whiteBg={true} nyeMode={true} />
    </div>
  </div>
</div>

    </Layout>
  );
};

export default DynamicLandingPage;
